import axios from "axios";

export async function fetchPublicIp() {
	const { data } = await axios.get("https://checkip.amazonaws.com", {
		timeout: 8000,
		transformResponse: [(response) => response],
	});

	const publicIp = String(data).trim();
	if (!publicIp) {
		throw new Error("No se pudo obtener la IP pública");
	}

	return publicIp;
}
